module.exports = __webpack_public_path__ + "assets/95c156ceb03a31181b2ffa37b577caba.png";